import BillingCompanyGroupIndex from "@/components/billing/company_group/BillingCompanyGroupIndex.vue";

let routesBillingCompanyGroup= [
    {
        path: '',
        meta: {
          title: "Billing Company Group",
        },
        name: "BillingCompanyGroupIndex",
        component: BillingCompanyGroupIndex
    },
    
]

export default routesBillingCompanyGroup
  